import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';

import { CampusResource } from 'src/app/core/models/api/campus-resource.model';
import { WebResource } from 'src/app/core/models/api/web-resource.model';

import { WebResourceService } from 'src/app/core/services/api/web-resource.service';

@Component({
    selector: 'app-component-selector',
    templateUrl: './component-selector.component.html',
    styleUrls: ['./component-selector.component.scss']
})
export class ComponentSelectorComponent implements OnInit, OnChanges, OnDestroy {

    @Input() campusId     : number;
    @Input() editionId    : number;
    @Input() webResourceId: string;

    public webResource: WebResource;
    public resources  : CampusResource[];

    private webResourceSubscription : Subscription;

    constructor(private webResourceService: WebResourceService) { }

    ngOnInit() { 
      
        this.webResourceService.getWebResource(this.editionId, this.webResourceId).subscribe();
        this.subscribeToWebResourceService();

    }
    ngOnChanges(changes: SimpleChanges) {
        
        if (changes.editionId || changes.campusId) {

            this.webResourceService.getWebResource(this.editionId, this.webResourceId).subscribe();
        
        }

    }
    
    ngOnDestroy() {
        
        if (this.webResourceSubscription && !this.webResourceSubscription.closed) { this.webResourceSubscription.unsubscribe(); }
    
    }

    private subscribeToWebResourceService() {

        this.webResourceSubscription = this.webResourceService.webResourceActiveData$.subscribe({
            next: (data) => { 
                this.webResource = data;
            }
        });

    }

}
